module.exports = __webpack_public_path__ + "img/IMG_6416 1.42eab712.png";